import { FunctionField, type FunctionFieldProps } from "react-admin";
import type { RaRecord } from "react-admin";

import {
  formatDisplayDateTime,
  formatListDate,
  type DateInput,
  type FormatDateOptions,
  type FormatDateTimeOptions,
} from "@/utils/date-format";

type DisplayDateFieldProps = Omit<FunctionFieldProps, "render"> & {
  source: string;
  /** When true, renders {@link formatDisplayDateTime} (`DD-MMM-YYYY HH:mm`). */
  showTime?: boolean;
  emptyText?: string;
  utc?: boolean;
  includeSeconds?: boolean;
};

function readSource(record: RaRecord | undefined, source: string): unknown {
  if (!record) return undefined;
  return record[source];
}

/** react-admin field using {@link formatListDate} or {@link formatDisplayDateTime}. */
export function DisplayDateField({
  source,
  showTime = false,
  emptyText = "—",
  utc = false,
  includeSeconds = false,
  ...rest
}: DisplayDateFieldProps) {
  const dateOptions: FormatDateOptions = { empty: emptyText, utc };
  const dateTimeOptions: FormatDateTimeOptions = {
    empty: emptyText,
    utc,
    includeSeconds,
  };

  return (
    <FunctionField
      {...rest}
      source={source}
      render={(record: RaRecord) => {
        const value = readSource(record, source) as DateInput;
        return showTime
          ? formatDisplayDateTime(value, dateTimeOptions)
          : formatListDate(value, dateOptions);
      }}
    />
  );
}

export default DisplayDateField;
